const HealthPage = () => <div style={{ fontSize: '32px' }}>OK</div>;

export default HealthPage;
